<template>
  <v-select
    id="user-role-selector"
    v-model="innerValue"
    name="user-role-selector"
    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
    :multiple="multiple"
    label="name"
    :options="items"
    :reduce="item => item.id"
    :placeholder="placeholder"
    autocomplete="chrome-off"
  />
</template>

<script>
import Role from '@nollaSdk/models/Role'
import vSelect from 'vue-select'

export default {
  components: {
    vSelect,
  },
  $_veeValidate: {
    name() {
      return this.name
    },
    value() {
      return this.value
    },
  },
  props: {
    value: {
      type: [Array, String],
      default: () => [],
    },
    error: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    multiple: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      innerValue: this.value,
      items: [],
      control: false,
    }
  },
  watch: {
    innerValue() {
      if (!this.control) {
        this.$emit('input', this.innerValue)
      }
      this.control = false
    },
    value() {
      this.control = true
      this.innerValue = this.value
    },
  },
  mounted() {
    this.findItems()
  },
  methods: {
    findItems() {
      Role.findAll()
        .then(models => {
          this.items = models
        })
    },
  },
}
</script>
